import { getStaticResourceUrl } from "../lib/utils";

export function LogoDesktopBlack() {
  return <img src={getStaticResourceUrl("logo/logo-desktop-black.png")} alt="logo" className="h-[28px] self-center" />;
}

export function LogoDesktopWhite() {
  return <img src={getStaticResourceUrl("logo/logo-desktop.png")} alt="logo" className="h-[28px] self-center" />;
}
